/**
 * Copyright © 2020 Exelon Corp. All Rights reserved.
 *
 * This file controle the enabling and disabling of specific features in this application
 *
 * Features:
 * - A feature can be enabled or disabled by setting a boolean flag as true or false
 * - Features defined in 'common' are applicable to all OpCos
 * - These features can be overridden at the opco level
 *
 * Referenced at:
 * - app.module.ts for instantiating the feature flag module
 * - *.spec.ts files for unit testing feature flags
 *
 */
import { EuAppFeatureFlags } from '@eucoms/common-components';

export const appFeatureFlags: EuAppFeatureFlags = {
  common: {
    global: {
      statusHeader: true,
    },
    dashboard: {
      showERTWithoutTime: true,
    },
    experiencingAnOutage: {
      isRouteEnabled: true,
    },
    preparingForAnOutage: {
      isRouteEnabled: true,
    },
  },
  BGE: {
    global: {
      statusHeader: true,
      showStormModeText: true,
    },
    GasOnly: {
      showlastUpdateLabel: true,
      showOutageMap: true,
    },
    InvalidScreen: {
      showOutageMap: true,
    },
    experiencingAnOutage: {
      showFullOutageMap: false,
      newFooterLinks: false,
    },
    preparingForAnOutage: {
      showFullCard: false,
    },
    dashboard: {
      etrMessage: false,
    },
  },
  ACE: {
    experiencingAnOutage: {
      showFullOutageMap: false,
      newFooterLinks: true,
    },
    preparingForAnOutage: {
      showFullCard: false,
    },
    dashboard: {
      etrMessage: false,
    },
  },
  DPL: {
    experiencingAnOutage: {
      showFullOutageMap: false,
      newFooterLinks: false,
    },
    preparingForAnOutage: {
      showFullCard: false,
    },
    dashboard: {
      etrMessage: false,
    },
  },
  PEPCO: {
    experiencingAnOutage: {
      showFullOutageMap: false,
      newFooterLinks: false,
    },
    preparingForAnOutage: {
      showFullCard: false,
    },
    dashboard: {
      etrMessage: false,
    },
  },
  PECO: {
    global: {},
    AccountDetails: {
      isFinalInactive: true,
    },
    InvalidScreen: {
      showOutageMap: true,
    },
    experiencingAnOutage: {
      showFullOutageMap: false,
      newFooterLinks: false,
    },
    preparingForAnOutage: {
      showFullCard: true,
    },
    dashboard: {
      etrMessage: false,
    },
  },
  ComEd: {
    experiencingAnOutage: {
      isRouteEnabled: false,
      showFullOutageMap: false,
      newFooterLinks: false,
      reportPowerOutageUrl: true,
    },
    preparingForAnOutage: {
      isRouteEnabled: false,
      showFullCard: false,
    },
    dashboard: {
      etrMessage: true,
      showERTWithoutTime: false,
    },
  },
};
